// HtmlLang.tsx / HtmlLang.jsx
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function HtmlLang() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const apply = () => {
      const lang = i18n.language?.toLowerCase().startsWith("ko") ? "ko" : "en";
      document.documentElement.lang = lang;

      // (선택) RTL 대비
      const rtl = ["ar", "he", "fa", "ur"].some((l) =>
        i18n.language?.toLowerCase().startsWith(l)
      );
      document.documentElement.dir = rtl ? "rtl" : "ltr";
    };

    apply();
    i18n.on("languageChanged", apply);
    return () => i18n.off("languageChanged", apply);
  }, [i18n]);

  return null;
}
